






























import { Component, Vue, Prop, Inject } from 'vue-property-decorator'

@Component
export default class PromotionPerfect extends Vue {
  @Prop({ default: () => {} }) readonly choice!: any

  @Inject({ from: 'toChoiceEP', default: null }) toChoiceEP!: any
  moreExposure(item: any) {
    const { spuId = '' } = item
    return this.toChoiceEP && this.toChoiceEP({ spuid: spuId })
  }
  moreClicked(item: any) {
    const { spuId = '' } = item
    this.$emit('toChoice', spuId)
    this.$router.push({ name: 'choice', query: { spuId } })
  }

  get choiceArray() {
    if (!this.choice.promotionList) {
      return []
    } else {
      if (this.choice.promotionList.length < 5) {
        return this.choice.promotionList
      }
      return this.choice.promotionList.slice(0, 5)
    }
  }
}
